import { Display } from '@koda/koda-components/atoms/Display';
import { Dialog, DialogClose, DialogContent, DialogFooter } from '@koda/koda-components/ui/dialog';
import { XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { cn } from '../../lib/utils/classnameVariants';

export interface ContentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  heading: string;
  footer?: React.ReactNode;
  className?: string;
  content: React.ReactNode;
}

const ContentDialog = ({ open, onOpenChange, heading, footer, className, content }: ContentDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent showCloseIcon={false} className={cn('h-5/6 overflow-y-auto p-0 md:max-w-5xl', className)}>
        <DialogClose className="absolute right-4 top-4 z-10 flex items-center gap-2 rounded-2xl transition-opacity hover:opacity-100 focus:outline-none focus:ring-0 disabled:pointer-events-none data-[state=open]:bg-white md:right-[185px] md:top-16 md:rounded-sm">
          <XMarkIcon className="size-6" />
          <span className="text-base font-graphik underline">Luk</span>
        </DialogClose>
        <div className="flex h-full px-4 pt-16 md:px-[185px] md:pt-[112px]">
          <div className="inline-flex w-full flex-col items-start justify-start gap-6 md:max-w-3xl">
            <Display tag="h1" textSize="5xl" textSizeMobile="3xl" className="pb-6">
              {heading}
            </Display>
            <div className="w-full [&>div[class*='col-span']]:w-full [&_.richText]:w-full [&_table]:w-full [&_table]:min-w-full">
              {content}
            </div>
          </div>
        </div>
        <DialogFooter className="mt-8 md:px-8 md:py-16">{footer}</DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ContentDialog;
